<template>
  <div class="agent-recharge-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">赠送记录</span>
      <span class="right_menu"></span>
    </div>
    <div class="search-box">
      <div class="search-item">
        <div class="select-time-box" @click="show_start_time = true">
          <template v-if="params.start_date.length > 0">
            <span>{{params.start_date}}</span>
            <div class="close-btn" @click.stop="params.start_date = ''">
              <van-icon name="close" size=".45rem" color="#cccccc" />
            </div>
          </template>
          <span class="placeholder" v-else>选择开始日期</span>
        </div>
        <div class="line">~</div>
        <div class="select-time-box" @click="selectTime()">
          <template v-if="params.end_date.length > 0">
            <span>{{ params.end_date }}</span>
            <div class="close-btn" @click.stop="params.end_date = ''">
              <van-icon name="close" size=".45rem" color="#cccccc"/>
            </div>
          </template>
          <span class="placeholder" v-else>选择结束日期</span>
        </div>
        <div class="search-btn" @click="initData()">搜索</div>
      </div>
      <div class="search-item">
        <div class="input-box">
          <img src="/static/image/new/agent/search-icon.png" class="icon" alt="">
          <input type="text" placeholder="输入账号" v-model="params.keyword">
        </div>
        <div class="search-btn" @click="initData()">搜索</div>
      </div>
      <div class="search-item">
        <div class="select-time-box" @click="show_user_type = true">
          <span>{{user_type_list.filter(item => {return item.type === params.user_type})[0].name}}</span>
          <div :class="{'arrow-btn': true, 'open-arrow': show_user_type}">
            <van-icon name="play" size=".32rem"/>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="list-box">
        <van-list finished-text="没有更多了" v-model="loading" offset="300" :finished="list.length === total"  @load="getList()" v-if="list.length > 0">
          <div class="list-item" v-for="(item,index) in list" :key="index">
            <div class="item-head">
              <div class="head-left">
                <div class="name">昵称: {{item.name}}</div>
                <div class="id">ID: {{item.id}}</div>
              </div>
              <div class="head-right">
                {{ item.date }}
              </div>
            </div>
            <div class="item-content">
              <div class="num-box">
                <div class="value">{{ item.after_money }}</div>
                <div class="label">
                  <img src="/static/image/new/agent/recharge-list-icon1.png" class="icon" alt="">
                  <span class="text">赠送前</span>
                </div>
              </div>
              <div class="num-box">
                <div class="value">{{ item.before_money }}</div>
                <div class="label">
                  <img src="/static/image/new/agent/recharge-list-icon2.png" class="icon" alt="">
                  <span class="text">赠送后</span>
                </div>
              </div>
              <div class="num-box">
                <div class="value">{{ item.amount }}</div>
                <div class="label">
                  <img src="/static/image/new/agent/recharge-list-icon3.png" class="icon" alt="">
                  <span class="text">赠送金额</span>
                </div>
              </div>
              <div class="num-box">
                <div class="value">{{ item.status_text }}</div>
                <div class="label">
                  <img src="/static/image/new/agent/recharge-list-icon4.png" class="icon" alt="">
                  <span class="text">到账状态</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div v-else style="margin-top: 60px; text-align: center">
          <img src="/static/image/new/agent/list-empy-img.png" style="width: 4.64rem;height: 4.64rem;" alt="" />
          <div class="text" style="color: #84B4FF;font-size: 0.37rem;margin-top: -0.8rem;">什么也没有</div>
        </div>
      </div>
    </div>

    <!--    开始时间    -->
    <van-calendar v-model="show_start_time" @confirm="onConfirm"
                  color="#1989fa"
                  :min-date="new Date(1900, 0, 1)"
                  :max-date="current_date" />
    <!--    结束时间    -->
    <van-calendar v-model="show_end_time" @confirm="onConfirm"
                  color="#1989fa"
                  v-if="params.start_date.length > 0"
                  :min-date="new Date(params.start_date)"/>
    <van-action-sheet
      v-model="show_user_type"
      :actions="user_type_list"
      cancel-text="取消"
      close-on-click-action
      @select="onSelectUserType"
    />
  </div>
</template>

<script>
import {translateText, getCurrentDay, formatDate} from "../../common/utils";

export default {
  name: 'agent-info',
  data(){
    return {
      params: {
        start_date: '',   // 开始时间
        end_date: '',    // 结束时间
        keyword: '',    // 搜索账户
        pageSize: 10,    // 每页条数
        page:   1,
        user_type: 'self',   // sub_agent：直属代理 direct_player：直属玩家 self：自己（默认值）

      },
      total: 0,
      current_date: new Date(),
      date: getCurrentDay(),
      show_start_time: false,
      show_end_time: false,
      loading: false,
      show_user_type: false,
      user_type_list: [{ name: '直属代理', type: 'sub_agent' }, { name: '直属玩家', type: 'direct_player' }, { name: '自己', type: 'self' }],
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    initData() {
      this.params.page = 1
      this.list = []
      this.total = 0
      this.getList()
    },
    selectTime() {
      if(this.params.start_date.length === 0){
        this.showTost(0, "请先选择开始时间")
        return;
      }
      this.show_end_time = true
    },
    onConfirm(date) {
      if(this.show_start_time){
        this.show_start_time = false
        this.params.start_date = formatDate(date)
        this.params.end_date = ''
      }else {
        this.show_end_time = false
        this.params.end_date = formatDate(date)
      }
    },
    async showTost(type, title) {
      // const message = await translateText([title]);
      this.$parent.showTost(type, title);
    },
    getList(){
      this.loading = true
      this.$apiFun
        .post('/api/zengsongList', {
          ...this.params
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.total = res.data.total
            if(this.params.page === 1) {
              this.list = res.data.data;
            }else {
              this.list = [...this.list, ...res.data.data];
            }
            this.params.page++;
          }
          this.loading = false
        })
        .catch(res => {
          this.loading = false
        });
    },
    onSelectUserType(item) {
      this.params.user_type = item.type
      this.params.page = 1
      this.getList()
    }

  },
}
</script>

<style scoped lang="scss">
.agent-recharge-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction:column;
  overflow: hidden;
  background: #F1F1F1;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    background: linear-gradient( 90deg, #3A8AFF 0%, #89AAFF 100%);
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.43rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .search-box {
    padding: 0.24rem .36rem 0;
    .search-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.24rem;
      .select-time-box {
        width: 3.6rem;
        height: 0.77rem;
        background: #fff;
        border-radius: .5rem;
        padding: 0 0.27rem;
        font-size: 0.24rem;
        line-height: .35rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        position: relative;
        .close-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: .1rem;
        }
        .arrow-btn {
          transform: rotate(-90deg);
          margin-left: .1rem;
          margin-top: 0.03rem;
          &.open-arrow {
            transform: rotate(90deg);
            margin-top: 0;
          }
        }
        .placeholder {
          color: #999999;
        }
      }
      .line {
        margin: 0 .15rem;
      }
      .input-box {
        display: flex;
        align-items: center;
        padding: 0 0.3rem 0 0.5rem;
        background: #fff;
        height: 0.77rem;
        flex: 1;
        border-radius: .5rem;
        .icon {
          width: 0.44rem;
          margin-bottom: .02rem;
          margin-right: .2rem;
        }
        input {
          flex: 1;
          height: 100%;
          outline: none;
          background: transparent;
          border: none;
          font-size: 0.29rem;
          &::-webkit-input-placeholder {
            color: #999999;
          }
        }
      }
      .search-btn {
        flex-shrink: 0;
        height: 0.75rem;
        line-height: 0.75rem;
        padding: 0 .19rem;
        background: linear-gradient( 90deg, #02BCEE 0%, #0B76FD 100%);
        border-radius: .37rem;
        font-size: 0.24rem;
        color: #fff;
        margin-left: .14rem;
        min-width: 1rem;
        text-align: center;
      }
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding: .24rem .36rem;
    .list-box {
      height: 100%;
      .list-item {
        margin-bottom: .24rem;
        .item-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient( 99deg, #03B7EF 0%, #0A7BFC 100%);
          color: #fff;
          padding: 0.19rem .19rem .49rem .19rem;
          border-top-left-radius: .24rem;
          border-top-right-radius: .24rem;
          font-size: 0.29rem;
          font-family: Gilroy;
          .name {
            margin-right: .24rem;
            max-width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .head-left {
            flex: 1;
            display: flex;
            align-items: center;
          }
          .head-right {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            font-family: PingFang SC;
            .arrow {
              margin-left: .06rem;
            }
          }
        }
        .item-content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          background: #fff;
          border-radius: .24rem;
          margin-top: -.25rem;
          padding: .24rem 0 0;
          .num-box {
            min-width: 22%;
            margin: 0 .29rem .48rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .value {
              font-family: Gilroy, Gilroy;
              font-size: 0.39rem;
              color: #0B7AFC;
            }
            .label {
              display: flex;
              align-items: center;
              margin-top: .1rem;
              .icon {
                width: 0.43rem;
              }
              .text {
                font-size: 0.29rem;
                color: #333333;
                margin-left: 0.17rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/giveAway.vue